import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "5. Информация о конструкции", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "5.1 Выберите тип конструкции", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, " Нажмите чтобы выбрать тип конструкции ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "5.2 Выберите место установки", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, " Нажмите чтобы выбрать место установки ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, " Нажмите если конструкции согласовываются по факту ", -1)
const _hoisted_17 = { class: "main_checkbox" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "app6" }, " Конструкции согласовываются используя приложение №6 ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "5.3 Выберите номер места", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, "Нажмите чтобы выбрать из списка", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!
  const _component_v_select_open = _resolveComponent("v-select-open")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.construction_options,
        title_select: _ctx.construction_title,
        onChangeSelect: _ctx.construction_select,
        default_select: _ctx.storeDM.save_obj.construction_type,
        key: _ctx.storeDM.save_obj.construction_type,
        z_index: 3,
        margin_top: '-6px'
      }, null, 8, ["options", "title_select", "onChangeSelect", "default_select"])),
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.placeinstall_options,
        title_select: _ctx.placeinstall_title,
        onChangeSelect: _ctx.placeinstall_select,
        default_select: _ctx.storeDM.save_obj.place_install,
        key: _ctx.storeDM.save_obj.place_install,
        z_index: 2,
        margin_top: '-6px'
      }, null, 8, ["options", "title_select", "onChangeSelect", "default_select"])),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("p", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "app6",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.save_obj.construction_app6) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.storeDM.save_obj.construction_app6]
        ]),
        _hoisted_18
      ]),
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.place_options,
        title_select: _ctx.place_title,
        onChangeSelect: _ctx.place_select,
        default_select: _ctx.storeDM.save_obj.place_number,
        key: _ctx.storeDM.save_obj.place_number,
        z_index: 1,
        margin_top: '-6px'
      }, null, 8, ["options", "title_select", "onChangeSelect", "default_select"])),
      _hoisted_22,
      _hoisted_23,
      _hoisted_24,
      (_ctx.storeDM.save_obj.place_number === 'manual')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "main_input",
            placeholder: "Ввести вручную",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeDM.save_obj.place_manual) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.place_manual]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_25)
  ], 64))
}